<template>
  <div class="bannerdiv">
    <!-- 代码 开始 -->
    <div class="slide-main" id="touchMain">
      <div class="slide-box" id="slideContent">
        <div class="slide" v-for="(item) in banner" :key="item.id">
          <template v-if="item.url.substr(0,4).toLowerCase()=='http'">
            <a :href="item.url">
              <img :src="item.image" width="1920" height="450" />
            </a>
          </template>
          <template v-else>
            <router-link :to="item.url">
              <img :src="item.image" width="1920" height="450" />
            </router-link>
          </template>
        </div>
      </div>
      <div class="pabsolute control">
        <div class="num fs18 twhite tcenter fbold pt10 pb10">01</div>
        <div class="btns tcenter bgw pt15 pb15">
          <a class="prev preNext dinline-block vcenter" href="javascript:;" stat="prev1001"></a>
          <span class="dinline-block fs18 vcenter tc6">|</span>
          <a class="next preNext dinline-block vcenter" href="javascript:;" stat="next1002"></a>
        </div>
      </div>
    </div>
    <!-- 代码 结束 -->
  </div>
</template>

<script>
import '../../assets/css/lrtk.css'
import liebaoBrowser from '../../assets/js/lrtk.js'
export default {
  name: "banner",
  props: [
    'banner'
  ],
  watch: {
  },
  methods:{
    dealBanner(){
      this.$nextTick(() => {
        var domEle = {
          navhover: $('.nav-main a'), detBtn: $('.details'),
          maxImg: $('.news-img'), fnLi: $('.ft-list li'),
          aniMation: liebaoBrowser.isCSS('animation'), watchLb: $('#watch-lb'),
          code: $('.watch-code'),
          downBtn: $('.beta-info a'),
          downlaodMain: $('.downlaod-main'),
          windowMain: $(window),
          bodyEle: $('body'),
          stopAnimte: $('.slide,.prev,.next,.item'),
          prev: $('.prev'),
          next: $('.next'),
          slide: $('.slide'),
          slideCur: $('.item a'),
          phoneImg: $('.phone-img'),
          codeImg: $('.code-img'),
          num: $('.slide-main .num'),
        };
        domEle.downlaodMain.show();
        liebaoBrowser.liebaoBrowser.init(domEle);
      })
    }
  },
  mounted() {
    $('.bannerdiv .preNext').click(function(){
      var index = 0;
      $('.slide-main .slide').each(function(){
        if($(this).css('display') == 'block'){
          index = $(this).index();

          return false;
        }
      })
      index ++;
      $('.bannerdiv .num').html('0' + index);
    })
    $('.topdiv input').focus(function(){
      var p = $(this).parent();
      p.css('box-shadow', '0 0 5px #fff');
    })
    $('.topdiv input').blur(function(){
      $(this).parent().css('box-shadow', 'none');
    })
  }
}
$(function(){
})
</script>

<style scoped>
  .bannerdiv .slide-main{height: 450px;}
  .bannerdiv .slide-main .control{z-index: 1024;left: 50%;margin-left: 360px;width: 200px;bottom: 50px;}
  .bannerdiv .slide-main .btns{padding: 18px 0;}
  .bannerdiv .slide-main .preNext{position: static;width: 55px;height: 22px;background: url(../../assets/images/cn1.png) no-repeat;}
  .bannerdiv .slide-main .prev{background-position: -28px -142px;}
  .bannerdiv .slide-main .next{background-position: -200px -142px;}
  .bannerdiv .slide-main .prev:hover{background-position: -28px -73px;}
  .bannerdiv .slide-main .next:hover{background-position: -200px -73px;}
  .bannerdiv .item a{margin-right: 8px;}
  .bannerdiv .item a span{width: 42px;height: 6px;border-radius: 10px;background:rgba(255,255,255,.5);}
  .bannerdiv .item a.cur span{background: #fff;}
</style>



// WEBPACK FOOTER //
// src/components/index/banner.vue